import Header from "./Components/Header/Header"
import Main from "./Components/Main/Main"
import Footer from "./Components/Footer/Footer"


import styles from "./index.module.scss"
import CheckNumber from "./Components/checknumber/checkNumber"
import { useState } from "react"

const Home = () => {
  const [show, setShow] = useState(true)

  return (
    <div className={styles.bodyBox}>
      <div className={styles.header}>
       <div>
            <svg
      viewBox="0 0 35.82 37.1"
      width={22}
      height={22}
      fill="#FFFFFF"
    >
      <path d="M4.46,6.35a8.38,8.38,0,0,1,8.15-2.94c2.71.55,4.26,2.77,4.78,5.43a6.31,6.31,0,0,1-2.75,6.79c-3.68,2.1-8,3.74-8.86,8.5A13.42,13.42,0,0,0,8.47,34.4C3.81,31.8,1.13,26.6.25,21.23A18,18,0,0,1,4.46,6.35" />
      <path d="M14.41,36.71A8.65,8.65,0,0,1,7.85,30.9a6.51,6.51,0,0,1,2.13-7,5.85,5.85,0,0,1,7.05-1c3.61,2.23,7.17,5.31,11.56,3.64A12.82,12.82,0,0,0,35.81,19C36,24.49,33,29.5,29,33a16.57,16.57,0,0,1-14.55,3.72" />
      <path d="M34.73,12.39a9.12,9.12,0,0,1-1.53,8.8c-1.79,2.17-4.42,2.47-6.91,1.63A6.18,6.18,0,0,1,21.92,17c0-4.35.81-9.1-2.8-12.17A12.51,12.51,0,0,0,9.05,2.33c4.47-2.92,10.27-2.89,15.22-1A17.36,17.36,0,0,1,34.73,12.39" />
    </svg>
       </div> United States Department of Transportation
      </div>

      <div className={styles.nav}>
        Connect your fuel provider EFS
      </div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default Home;
